import React from "react";
import { useParams } from "react-router-dom";

const OrderSuccess = () => {
  const params = useParams();

  return (
    <>
      <div id="qodef-page-inner" className="qodef-content-grid">
        <main
          id="qodef-page-content"
          className="qodef-grid qodef-layout--template"
        >
          <div className="qodef-grid-inner clear">
            <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
              <div className="woocommerce">
                <div className="woocommerce-notices-wrapper" />
                <div id="qodef-woo-page" className="qodef--checkout">
                  <div className="col2-set" id="customer_details">
                    <div className="col-1">
                      <center>
                        <div className="woocommerce-billing-fields">
                          <h3>Order Status</h3>
                          <img
                            src="https://i.ibb.co/tTqvs3SX/image.png"
                            style={{ maxHeight: "350px" }}
                            alt="order_success"
                          />
                          <h3>Order ID: {params.oid}</h3>
                          <p>
                            Yaaaay! Your Order was successful, Keep your order
                            id handy for tracking your order
                          </p>
                          <a href="/Track-Order">
                            <button
                              className="button alt qodef-borders--added"
                              name="woocommerce_checkout_place_order"
                            >
                              Track Your Order
                            </button>
                          </a>
                        </div>
                      </center>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default OrderSuccess;
